import React, {useState} from 'react';
import ValidationError from "~/Components/Forms/ValidationError";

const AdminTokenForm = ({values, errors, onChange}) => {

    const defaultFields = {
        token: '',
        value: '',
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <div>
            <div className="form-group">
                <label>Token</label>

                <input
                    onChange={handleChange}
                    value={form.token}
                    name="token"
                    type="text"
                    className="form-control"/>

                {form.token && (
                    <small>Token <strong>[{form.token}]</strong> will be replaced with value in any translation!</small>
                )}

                <ValidationError errors={errors} name="token"/>
            </div>
            <div className="form-group">
                <label>Value</label>
                <textarea
                    onChange={handleChange}
                    value={form.value}
                    name="value"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="value"/>
            </div>

        </div>
    );
}


export default AdminTokenForm;
